export default {
    url: '/by_dau',
    template: require('./view.html'),
    reloadOnSearch: false,
    data: {
        priority: 901,
        title: 'By DAU',
        role: 'conversion_rate',
    },
};
